import React from 'react'

import { PaywallContext } from '../PaywallContext'
import { usePaywallModal } from '@/hooks/usePaywallModal'

type PaywallProviderProps = {
  children: React.ReactNode
}

export function PaywallProvider({
  children,
}: PaywallProviderProps): JSX.Element {
  const [PaywallModalComponent, showPaywallModal, hidePaywallModal] =
    usePaywallModal()

  return (
    <PaywallContext.Provider value={{ showPaywallModal, hidePaywallModal }}>
      {PaywallModalComponent}
      {children}
    </PaywallContext.Provider>
  )
}
